const s = {
  name: "Lenses",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,16c-2.2,0-4,1.8-4,4s1.8,4,4,4c2.2,0,4-1.8,4-4S22.2,16,20,16z M18,20c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2
			c0,1.1-0.9,2-2,2C18.9,22,18,21.1,18,20z"/>
		<path class="st0" d="M0,20c0,11,9,20,20,20c11,0,20-9,20-20S31,0,20,0C9,0,0,9,0,20z M5,10c3-4.5,8.1-7.6,13.8-8L9.6,18l-4.3-7.5
			L5,10z M2,20c0-2.9,0.7-5.6,1.9-8l5.8,10l0,0l3.5,6H3.9C2.7,25.6,2,22.9,2,20z M18.9,38C13.1,37.6,8.1,34.5,5,30h18.4l-4.3,7.5
			L18.9,38z M35,30c-3,4.5-8.1,7.6-13.8,8l9.2-16l4.3,7.5L35,30z M38,20c0,2.9-0.7,5.6-1.9,8l-9.2-16h9.2C37.3,14.4,38,17.1,38,20z
			 M21.1,2c5.8,0.4,10.8,3.4,13.8,8H16.5l4.3-7.5l0,0L21.1,2z M10.8,20l4.6-8h9.2l4.6,8l-4.6,8h-9.2L10.8,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Lenses
};
